import { ChartConfiguration, ChartData } from 'chart.js/dist/types'
import { ChartDataset } from 'chart.js'

export function buildChartData(uniqueClusterIds: string[], datasets: ChartDataset[]): ChartData {
  return {
    labels: uniqueClusterIds,
    datasets,
  }
}

export function buildTopQuestionsChart(chartData: ChartData): ChartConfiguration {
  return {
    type: 'line',
    data: chartData,
    options: {
      responsive: true,
      animation: { duration: 0 },
      plugins: {

        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        tooltip: {
          mode: 'point',
          axis: 'xy',
        },

      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      scales: {
        x: {
          title: {
            display: true,
            text: 'Day',
          },
        },
        y: {
          stacked: true,
          title: {
            display: true,
            text: 'Number of questions',
          },
        },
      },
    },
  }
}
